import React from "react";
import { Button } from "@mui/material";
import box from "../images/imkon_box.svg";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";

const Imkoniyatlar = () => {
  const lang = localStorage.getItem("i18nextLng");

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    pauseOnHover: false,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1124,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 924,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 840,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const { t } = useTranslation();

  return (
    <div className="imkoniyat_container" id="imkoniyat">
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"
        data-aos-duration="700"
      >
        <div className="imkon_header">
          <h2 className={lang === "ru" ? "title active" : "title"}>
            {t("OPPORTUNITIES.TITLEONE")}
          </h2>
          <h4 className={lang === "ru" ? "title_next active" : "title_next"}>
            {t("OPPORTUNITIES.TITLETWO")}
          </h4>
        </div>
      </div>
      <div className="imkon_content">
        <Slider {...settings} className="slide">
          <div
            data-aos="zoom-in"
            data-aos-anchor-placement="top-bottom"
            data-aos-duration="500"
          >
            <div className="imkon_box">
              <img src={box} alt="box" />
              <div className="box_header">
                <h3>{t("OPPORTUNITIES.CARDTITLE1")}</h3>
              </div>
              <div className="box_content">
                <p>{t("OPPORTUNITIES.CARDDESCRIPTION1")}</p>
              </div>
            </div>
          </div>

          <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
            <div className="imkon_box">
              <img src={box} alt="box" />
              <div className="box_header">
                <h3>{t("OPPORTUNITIES.CARDTITLE2")}</h3>
              </div>
              <div className="box_content">
                <p>{t("OPPORTUNITIES.CARDDESCRIPTION2")}</p>
              </div>
            </div>
          </div>

          <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
            <div className="imkon_box">
              <img src={box} alt="box" />
              <div className="box_header">
                <h3>{t("OPPORTUNITIES.CARDTITLE3")}</h3>
              </div>
              <div className="box_content">
                <p>{t("OPPORTUNITIES.CARDDESCRIPTION3")}</p>
              </div>
            </div>
          </div>

          <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
            <div className="imkon_box">
              <img src={box} alt="box" />
              <div className="box_header">
                <h3>{t("OPPORTUNITIES.CARDTITLE4")}</h3>
              </div>
              <div className="box_content">
                <p>{t("OPPORTUNITIES.CARDDESCRIPTION4")}</p>
              </div>
            </div>
          </div>

          <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
            <div className="imkon_box">
              <img src={box} alt="box" />
              <div className="box_header">
                <h3>{t("OPPORTUNITIES.CARDTITLE5")}</h3>
              </div>
              <div className="box_content">
                <p>{t("OPPORTUNITIES.CARDDESCRIPTION5")}</p>
              </div>
            </div>
          </div>

          <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
            <div className="imkon_box">
              <img src={box} alt="box" />
              <div className="box_header">
                <h3>{t("OPPORTUNITIES.CARDTITLE6")}</h3>
              </div>
              <div className="box_content">
                <p>{t("OPPORTUNITIES.CARDDESCRIPTION6")} </p>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default Imkoniyatlar;
